<template>
  <div class="bookgroup">
    <div class="campus">教材系列管理</div>
    <el-card :span="24">
      <div class="header">全部教材系列
        <el-button v-if="moduleAccessAdminEnabled" type="text" @click="$router.push({ name: 'moduleAccess', query: { miniid: miniId } })">模块权限</el-button>
      </div>
      <div class="content">
        <el-button type="primary" class="mb-24" @click="openAddDialog">新增教材</el-button>
        <div class="tableStyle">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="groupName" label="教材系列名称" min-width="50" align="center">
            </el-table-column>
            <el-table-column prop="bookName" label="书本名称" min-width="50" align="center">
            </el-table-column>
            <el-table-column prop="bookShortName" label="书本简称" min-width="50" align="center">
            </el-table-column>
            <el-table-column label="操作" width="300">
                <template slot-scope="scope">
                  <el-button type="text"  @click="delMaterial(scope.row)">解绑教材</el-button>
                </template>
              </el-table-column>
          </el-table>
        </div>
        <div class="dz-flex dz-flex-justify-end mt-12">
          <el-pagination background @size-change="getMaterialList" @current-change="getMaterialList" :current-page.sync="page"
            :page-sizes="[5, 10, 30, 50, 100]" :page-size.sync="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <!-- 会话框 -->
    <div class="dialogStyle">
      <!-- 新建,编辑教材分类 -->
      <el-dialog title="新增教材" :visible.sync="publicDialog" width="800px" center>
        <div class="query">
          <el-form>
            <el-form-item label="书本名称：" class="dz-flex">
              <el-input v-model="bookTitle" placeholder="请输入书本名称进行查询"></el-input>
              <!-- <el-button class="ml-20" type="primary" @click="titleSelect">查询</el-button> -->
            </el-form-item>
            <el-form-item label="书本系列：" class="dz-flex">
              <el-input v-model="groupName" placeholder="请输入书本名称进行查询"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="ml-20" type="primary" @click="titleSelect(bookTitle,groupName)">查询</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableStyle">
          <el-table :data="bookList" style="width: 100%">
              <el-table-column prop="groupName" label="教材系列名称" min-width="100" align="center">
              </el-table-column>
              <el-table-column prop="bookName" label="书本名称" min-width="100" align="center">
              </el-table-column>
              <el-table-column prop="bookShortName" label="书本简称" min-width="100" align="center">
              </el-table-column>
              <el-table-column label="操作" >
                <template slot-scope="scope">
                  <el-button type="text"  @click="addMaterial(scope.row)">添加</el-button>
                </template>
              </el-table-column>
          </el-table>
        </div>
        <div class="dz-flex dz-flex-justify-end mt-12">
          <el-pagination background @size-change="getNotRelatedMaterialList(bookTitle,groupName)" @current-change="getNotRelatedMaterialList(bookTitle,groupName)" :current-page.sync="bookPage"
            :page-sizes="[5, 10, 30, 50, 100]" :page-size.sync="bookPageSize" layout="total, sizes, prev, pager, next, jumper" :total="bookTotal">
          </el-pagination>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="publicDialog = false">关闭</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { $debounce } from '@/utils/index';
// 这里只提供当前 miniId 的管理入口，最终可编辑范围由权限 API 决定。
import { moduleAccessAdminEnabled } from '@/api/moduleAccess';

export default {
  name: 'bookgroup',
  props: ['orgId','miniId'],
  data() {
    return {
      moduleAccessAdminEnabled,
      tableData: [],
      bookList:[],

      page: 1,
      pageSize: 10,
      total: 0,

      bookPage:1,
      bookPageSize:5,
      bookTotal:0,
      bookTitle:'',
      groupName:'',
      publicDialog: false,
    };
  },
  created() {
    this.$nextTick(() => {
      // 调用 查询出版社列表
      this.getMaterialList();
    });
  },
  methods: {
    // 查询相关教材列表
    async getMaterialList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/mini/miniBook/selectBookByMiniprogram',
        method: 'GET',
        params: {
            orgId:this.orgId,
            miniId:this.miniId,
            page: this.page,
            pageSize: this.pageSize,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.tableData = result.data.data;
          this.total = result.data.size;
        })
        .catch((err) => {
          return this.$message.error('查询失败！：' + err);
        });
    },
    // 解绑相关教材
    delMaterial(row){
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/mini/miniBook/relatedBookToMiniprogram/del/' + row.id,
        method: 'POST',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.$message.success(result.data.message)
          this.getMaterialList();
        })
        .catch((err) => {
          return this.$message.error('查询失败！：' + err);
        });
    },
    openAddDialog() {
      this.bookTitle = '';
      this.groupName = '';
      this.publicDialog = true;
      this.getNotRelatedMaterialList();
    },
    // 查询未联系的教材列表
    getNotRelatedMaterialList(title,group){
      console.log(title,group)
      let params = {
            orgId:this.orgId,
            miniId:this.miniId,
            title:'',
            groupName:group,
            page: this.bookPage,
            pageSize: this.bookPageSize,
        }
        if (title === 'title') {
          params.title = this.bookTitle
        } else if(title != undefined && title != null && title != ''){
          params.title = title
        }
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/mini/miniBook/selectNotRelatedBookByMiniprogram',
        method: 'GET',
        params: params,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.bookList = result.data.data;
          this.bookTotal = result.data.size;
        })
        .catch((err) => {
          return this.$message.error('查询失败！：' + err);
        });
    },
    titleSelect(bookTitle,groupName){
      this.bookPage = 1,
      this.getNotRelatedMaterialList('title',groupName);
    },
    // 新增教材
    addMaterial:$debounce(function (row) {
      row.orgId = this.orgId;
      row.miniId = this.miniId;
      let data = {relatedBookList:[]};
      data.relatedBookList.push(row);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/mini/miniBook/relatedBookToMiniprogram',
        method: 'POST',
        data:data,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.getNotRelatedMaterialList(this.bookTitle,this.groupName);
          this.getMaterialList();
          this.$message.success(result.data.message);
        })
        .catch((err) => {
          return this.$message.error('查询失败！：' + err);
        });
    },500),
  },
};
</script>

<style lang="less" scoped>
.bookgroup {
  .el-card__body {
    padding: 0 1.3vw;
  }
  .query{
    /deep/.el-input{
      width: 280px;
    }
  }
}
</style>